import React, { memo, useCallback, useMemo } from 'react';
import { ChevronRight } from '@material-ui/icons';
import { Divider } from '@material-ui/core'
import { ReactComponent as PayPalLogo } from 'payment-icons/min/single/paypal.svg';
import { ReactComponent as DefaultLogo } from 'payment-icons/min/outline/default.svg';
import { ReactComponent as ReleaseHubLogo } from '../../assets/social-logos/releasehub-dark.svg';
import { ReactComponent as AppleLogo } from '../../assets/social-logos/apple-black.svg';
import { ReactComponent as GooglePlayLogo } from '../../assets/social-logos/google-play.svg';
import CreditCardLogo from './CreditCardLogo';
import { useAuth } from '../../firebase/Auth';
import FallbackImage from '../FallbackImage';
import { CheckoutProviderProps } from './context/CheckoutContext';
import { isPlatform } from '@ionic/react';
import { formatMoney } from '../../utils/Helpers';
import { PaymentMethod } from '../../generated/graphql';

const CheckoutOverview: React.FC<CheckoutProviderProps> = memo((props) => {

    const { onPurchase, onGoForward, product, paymentMethod, onGetBraintreePaymentMethod, customerData, deviceData } = props;

    const { user } = useAuth();

    const braintreePaymentMethod = useMemo(() => {
        return onGetBraintreePaymentMethod();
    }, [onGetBraintreePaymentMethod])

    const getPaymentMethod = useCallback(() => {

        if (paymentMethod === PaymentMethod.InAppPurchase) {
            return (
                <>
                    {isPlatform("ios") ? (
                        <AppleLogo className="w-auto h-6 m-2" />
                    ) : (
                        <GooglePlayLogo className="w-auto h-6 m-2" />
                    )}
                </>
            )
        }

        if (paymentMethod === PaymentMethod.Wallet) {
            return (
                <ReleaseHubLogo className="w-auto h-6 m-2" />
            )
        }

        switch (braintreePaymentMethod?.__typename) {
            case "BraintreeCreditCard":
                if (braintreePaymentMethod.cardType) {
                    return <CreditCardLogo size="md" type={braintreePaymentMethod.cardType} />
                } else {
                    return <DefaultLogo className="w-auto h-8" />
                }
            case "BraintreePayPalAccount":
                return <PayPalLogo className="w-auto h-10" />
            default:
                return <div className="py-2 text-sm text-purple-600">Select Payment Method</div>
        }
    }, [paymentMethod, braintreePaymentMethod])

    return (
        <>
            <div className="flex items-center mb-3">
                <div className="w-12 h-12 overflow-hidden rounded-full">
                    {user?.imageURL ? <img className="object-cover w-full h-full" src={user.imageURL} alt="" /> : <FallbackImage size="sm" />}
                </div>
                <div className="ml-3">
                    <div className="font-bold">{user?.username}</div>
                    <div className="text-xs opacity-70">Encore</div>
                </div>
            </div>
            <div className="">
                <Divider />
            </div>
            <button disabled={paymentMethod === undefined} className="w-full p-3 cursor-pointer active:bg-black active:bg-opacity-10 disabled:opacity-25" onClick={() => onGoForward('payment_method')}>
                <div className="flex items-center justify-between">
                    <div className="text-sm opacity-70">Payment Method</div>
                    <div className="flex items-center">
                        <div>
                            {getPaymentMethod()}
                        </div>
                        <ChevronRight />
                    </div>
                </div>
            </button>
            <div className="">
                <Divider />
            </div>
            <div className="p-3 active:bg-black dark:active:bg-white active:bg-opacity-10">
                <div className="flex items-center justify-between">
                    <div className="text-sm opacity-70">Total</div>
                    <div className="flex items-center h-10">
                        <div className="mr-2 text-sm">{formatMoney(product?.price)}</div>
                        {/* <ChevronRight /> */}
                    </div>
                </div>
            </div>
            <div className="">
                <Divider />
            </div>
            <div className="py-5 text-xs">
                <div>By placing an order you agree to our</div>
                <div className="mt-1 font-bold underline">Terms and Conditions</div>
            </div>
            <div className="">
                <button className="w-full focus:outline-none black-button" onClick={onPurchase} disabled={
                    paymentMethod === undefined
                    || (paymentMethod === PaymentMethod.Braintree && (!braintreePaymentMethod?.token || !deviceData))
                    || product === undefined
                    || (!isPlatform("capacitor") && !customerData?.user?.braintreeCustomer)
                    || (paymentMethod === PaymentMethod.Wallet && ((user?.wallet ?? 0) < (product?.price ?? 0)))
                }>
                    Place Order
                </button>
            </div>
        </>
    );
});

export default CheckoutOverview;
